import type { NamedPathLookupAdvancedOptions } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SelectAdvancedOptionsCommand {
  advancedOptions: NamedPathLookupAdvancedOptions;
}

export const selectAdvancedOptions: GraphCommandFactory<
  SelectAdvancedOptionsCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.pathlookup.selectedAdvancedOptions = command.advancedOptions;
  });
};
